import { FC } from 'react';
import { Container } from '@qga/roo-ui/components';
import useTitleOnMount from 'hooks/useTitleOnMount';
import PageHeader from 'components/PageHeader';
import Filter from './Filter';
import BookingList from './BookingList';
import BookingListHeading from './BookingListHeading';
import BookingListResultSummary from './BookingListResultSummary';
import BookingListProvider, { useBookingList } from './BookingListProvider';
import ErrorPage from '../ErrorPage';

const BookingListContent: FC = () => {
  useTitleOnMount('My hotel bookings');

  const { error } = useBookingList();

  if (error) {
    return <ErrorPage />;
  }

  return (
    <>
      <PageHeader title="My hotel bookings" />

      <Container>
        <Filter height="48px" width={['100%', '390px']} mt={[6, 10]} />
        <BookingListHeading mt={[5, 8]} />
        <BookingListResultSummary mt={[5, 4]} />
        <BookingList mt={[5, 3]} />
      </Container>
    </>
  );
};

const BookingListPage: FC = () => (
  <BookingListProvider>
    <BookingListContent />
  </BookingListProvider>
);

export default BookingListPage;
